import { actionTypes } from './constants';

export const runPagesActionTypes = {
  setSelectedRunIds: actionTypes.PIPELINE_PAGES_SET_SELECTED_RUN_IDS,
  setFetching: actionTypes.RUNS_PAGES_SET_FETCHING,
};
